module.exports = __webpack_public_path__ + "img/picture-default.eba7a567.jpg";